export function writeJSON(key: string, value: any, storageObject: Storage = localStorage) {
  storageObject.setItem(key, JSON.stringify(value));
}

export function readJSON<T>(key: string, defaultValue: T, storageObject: Storage = localStorage) {
  let result: T;
  try {
    const json = storageObject.getItem(key);
    if (json != null) {
      result = JSON.parse(json);
    }
    else {
      result = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    }
    writeJSON(key, result, storageObject);
  }
  catch (e) {
    console.log(e);
    result = defaultValue;
    writeJSON(key, result, storageObject);
  }
  return result;
}

const storage = {
  writeJSON,
  readJSON
};

export default storage;
